"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = exports.List = exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _elements = require("../../elements");

var _utils = require("../../utils");

var styles = {
  "list": "author-list-2f3yu",
  "link": "author-link-kkFKG",
  "show-more": "author-show-more-3eCQp",
  "hide": "author-hide-2Xk-6",
  "showMore": "author-show-more-3eCQp"
};

var Item = function Item(_ref) {
  var name = _ref.name,
      className = _ref.className,
      htmlProps = (0, _objectWithoutProperties2["default"])(_ref, ["name", "className"]);
  return /*#__PURE__*/_react["default"].createElement("li", (0, _extends2["default"])({
    itemProp: "author",
    itemScope: "",
    itemType: "https://schema.org/Person",
    className: _utils.classNames.use(className)
  }, htmlProps), /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://core.ac.uk/search?q=author:(".concat(name, ")"),
    className: styles.link
  }, name.replace(',', ' ')));
};

exports.Item = Item;
Item.displayName = "Item";

var List = function List(_ref2) {
  var authors = _ref2.authors,
      className = _ref2.className,
      htmlProps = (0, _objectWithoutProperties2["default"])(_ref2, ["authors", "className"]);
  var showMoreRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  (0, _react.useEffect)(function () {
    if (isExpanded) showMoreRef.current.parentElement.nextElementSibling.firstChild.focus();
  }, [isExpanded]);

  if (authors.length <= 4) {
    return /*#__PURE__*/_react["default"].createElement("ol", (0, _extends2["default"])({
      className: _utils.classNames.use(styles.list).join(className)
    }, htmlProps), authors.map(function (author) {
      return /*#__PURE__*/_react["default"].createElement(Item, {
        name: author.name
      });
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("ol", (0, _extends2["default"])({
    className: _utils.classNames.use(styles.list).join(className)
  }, htmlProps), /*#__PURE__*/_react["default"].createElement(Item, {
    "aria-setsize": authors.length,
    name: authors[0].name
  }), /*#__PURE__*/_react["default"].createElement(Item, {
    "aria-setsize": authors.length,
    name: authors[1].name
  }), /*#__PURE__*/_react["default"].createElement("li", {
    "aria-setsize": authors.length,
    className: _utils.classNames.use(styles.showMore, isExpanded && styles.hide)
  }, /*#__PURE__*/_react["default"].createElement(_elements.Button, {
    ref: showMoreRef,
    onFocus: function onFocus() {
      setIsExpanded(true);
    },
    title: "Show more authors"
  }, "+\u2000", authors.length - 3, " more")), authors.slice(2, -1).map(function (author) {
    return /*#__PURE__*/_react["default"].createElement(Item, {
      "aria-setsize": authors.length,
      key: author.name,
      name: author.name,
      className: !isExpanded && styles.hide
    });
  }), /*#__PURE__*/_react["default"].createElement(Item, {
    "aria-setsize": authors.length,
    name: authors[authors.length - 1].name
  }));
};

exports.List = List;
List.displayName = "List";
List.displayName = 'AuthorList';
Item.displayName = 'AuthorList.Item';
List.Item = Item;
var _default = List;
exports["default"] = _default;